export enum ElementCacheType {
    Entity = "loadEntitySimpleInfo",
    Service = "loadServiceSimpleInfo",
    Procedure = "loadProcedureSimpleInfo",
}

export const ELEMENT_CACHE_TYPE = [
    { id: ElementCacheType.Entity, name: "Entity" },
    { id: ElementCacheType.Service, name: "Service" },
    { id: ElementCacheType.Procedure, name: "Procedure" }
]